import { render, staticRenderFns } from "./Abriefhistory.vue?vue&type=template&id=7de9a933&"
import script from "./Abriefhistory.vue?vue&type=script&lang=ts&"
export * from "./Abriefhistory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports